import { render, staticRenderFns } from "./material-movement-overview.vue?vue&type=template&id=773ad847&"
import script from "./material-movement-overview.vue?vue&type=script&lang=js&"
export * from "./material-movement-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports